import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { Flex, Spin } from "@ir/ui";

/**
 * Auth Callback Page - Presentation layer
 * Single Responsibility: Handles Auth0 callback after authentication
 */
export const AuthCallback = () => {
  const { isLoading, isAuthenticated, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Redirect to organizations page after successful authentication
        navigate("/organizations", { replace: true });
      } else if (error) {
        // Handle error - redirect to home
        console.error("Authentication error:", error);
        navigate("/", { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, error, navigate]);

  return (
    <Flex
      align="center"
      justifyContent="center"
      style={{
        height: "100vh",
      }}
    >
      <Spin tip="Completing authentication..." spinning={true} />
    </Flex>
  );
};
